exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report[data-v-3715b36c]{margin-top:30px}.center[data-v-3715b36c]{text-align:center}.btn-export[data-v-3715b36c]{text-align:right;margin-bottom:.25rem}.break-word[data-v-3715b36c]{word-break:break-all}.colour-pdf[data-v-3715b36c]{color:red}.colour-excel[data-v-3715b36c]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3715b36c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportes/materiales/ReporteMateriales.vue
// module id = 252
// module chunks = 58